var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"px-4",attrs:{"app":"","flat":"","clipped-left":"","color":"background"}},[_c('v-toolbar-title',{staticClass:"font-weight-medium pl-2"},[_vm._v("Sumon")]),_c('v-spacer'),_c('LangSwitcher'),_c('ThemeSwitcher')],1)}
var staticRenderFns = []

export { render, staticRenderFns }